import { combineReducers } from "redux";
import memory from "./memory";
// import session from "./session";
// import storage from "./storage";

export default combineReducers({
  memory,
  // session,
  // storage
});